import { VBtn } from 'vuetify/lib/components/VBtn';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VSpacer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.usuarioLogado)?_c(VFooter,{staticStyle:{"justify-content":"center"},attrs:{"color":"#283275","width":"auto"}},[_c('p',{staticClass:"textofooter"},[_vm._v("COPYRIGHT © "+_vm._s(new Date().getFullYear())+" - AICONSUMER")]),_c(VSpacer),_c(VBtn,{attrs:{"icon":"","dark":"","href":"https://www.instagram.com/intelite_tecnologia/","target":"_blank"}},[_c('img',{attrs:{"src":require("../assets/instagram.png")}})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }